module.exports = __webpack_public_path__ + "img/pay3.884495ad.png";